import BloqueioLicencaService from "@/services/BloqueioLicencaService";

export const bloqueioLicenca = {
  namespaced: true,
  state: {
    bloqueioLicenca: {},
  },
  actions: {
    getBloqueioLicenca({ commit }, payload) {
      return BloqueioLicencaService.GetBloqueioLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postBloqueioLicenca({ commit }, payload) {
      return BloqueioLicencaService.PostBloqueioLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putBloqueioLicenca({ commit }, payload) {
      return BloqueioLicencaService.PutBloqueioLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteBloqueioLicenca({ commit }, payload) {
      return BloqueioLicencaService.DeleteBloqueioLicenca(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getBloqueioLicencaOData({ commit }, payload) {
      return BloqueioLicencaService.GetBloqueioLicencaOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default bloqueioLicenca;
